import { render, staticRenderFns } from "./SOCSlider.vue?vue&type=template&id=b9a11c06&scoped=true"
import script from "./SOCSlider.vue?vue&type=script&lang=ts"
export * from "./SOCSlider.vue?vue&type=script&lang=ts"
import style0 from "./SOCSlider.vue?vue&type=style&index=0&id=b9a11c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a11c06",
  null
  
)

export default component.exports